import { FormControl, FormGroup } from '@angular/forms';
import { FormAdapterBase } from '../form-adapter-base';

export class AddressTypeAdapter<T extends FormGroup> extends FormAdapterBase<T, FormGroup> {

    private readonly addressTypeKey: string;

    private readonly mortgageAmountKey: string;

    private readonly rentalAmountKey: string;

    public constructor(
        form: T,
        basePath: string,
        addressTypeKey = 'addressType',
        mortgageAmountKey = 'mortgageAmount',
        rentalAmountKey = 'rentalAmount',
    ) {
        super(form, basePath);
        this.addressTypeKey = addressTypeKey;
        this.mortgageAmountKey = mortgageAmountKey;
        this.rentalAmountKey = rentalAmountKey;
    }

    public get addressTypeControl(): FormControl {
        return this.getTargetForm().get(this.addressTypeKey) as FormControl;
    }

    public get mortgageControl(): FormControl {
        return this.getTargetForm().get(this.mortgageAmountKey) as FormControl;
    }

    public get rentalControl(): FormControl {
        return this.getTargetForm().get(this.rentalAmountKey) as FormControl;
    }

    public override apply(): void {
        switch(this.addressTypeControl.value) {
            case 'mortgage':
                this.rentalControl.enabled && this.rentalControl.disable();
                this.mortgageControl.disabled && this.mortgageControl.enable();
                break;
            case 'rental':
                this.mortgageControl.enabled && this.mortgageControl.disable();
                this.rentalControl.disabled && this.rentalControl.enable();
                break;
            default:
                this.disableAll();
                break;
        }
    }

    private disableAll(): void {
        this.mortgageControl.enabled ? this.mortgageControl.disable() : '';
        this.rentalControl.enabled ? this.rentalControl.disable() : '';
    }
}
